import { forwardRef } from 'react'
import PropTypes from 'prop-types'

import './FormControls.scss'

const PrefixInput = forwardRef(function PrefixInput({ prefix, suffix, error, className, inputClassName, disabled, type = 'text', inputMode = 'decimal', ...inputProps }, ref) {
  return (
    <div className={[
      'prefix-input',
      error ? 'prefix-input--error' : '',
      disabled ? 'prefix-input--disabled' : '',
      className || '',
    ].filter(Boolean).join(' ')}>
      {prefix && <span className="prefix-input__tag">{prefix}</span>}
      <input
        {...inputProps}
        ref={ref}
        type={type}
        inputMode={inputMode}
        className={inputClassName}
        disabled={disabled}
        aria-invalid={Boolean(error)}
      />
      {suffix && <span className="prefix-input__suffix">{suffix}</span>}
    </div>
  )
})

PrefixInput.propTypes = {
  prefix: PropTypes.node,
  suffix: PropTypes.node,
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.node]),
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  disabled: PropTypes.bool,
}

export default PrefixInput
